import { useSyncExternalStore } from "react";

// Subscribing to nothing: hydration status never changes after the first client
// render, so there's no store to listen to.
const noopSubscribe = () => () => {};

/**
 * Returns `false` on the server and during the first client render, then `true`
 * once hydration has completed. This is the setState-free replacement for the
 * `const [mounted, setMounted] = useState(false); useEffect(() => setMounted(true), [])`
 * pattern — same semantics, but without a render-triggering effect.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    noopSubscribe,
    () => true, // client snapshot (post-hydration)
    () => false, // server snapshot
  );
}
